import { sessionStorageUtil } from '@utils/session-storage.util';
import { SESSION_KEYS } from '@utils/session-keys.constants';

export const WEB_SESSION_QUERY_PARAM = 'websessionid';
export const LEGACY_WEB_SESSION_QUERY_PARAM = 'Websessionid';

/** Builds `?websessionid=…` (and optional extra params) with a single encode pass. */
export const buildWebSessionSearch = (webSessionId: string, existingSearch = ''): string => {
  const params = new URLSearchParams(
    existingSearch.startsWith('?') ? existingSearch.slice(1) : existingSearch,
  );
  params.delete(WEB_SESSION_QUERY_PARAM);
  params.delete(LEGACY_WEB_SESSION_QUERY_PARAM);
  params.set(WEB_SESSION_QUERY_PARAM, webSessionId.trim());
  return `?${params.toString()}`;
};

/** Persist session to storage + current URL (shared by App bootstrap, cancel flow, etc.). */
export const persistWebSessionId = (webSessionId: string): void => {
  const value = webSessionId.trim();
  sessionStorageUtil.set(SESSION_KEYS.WEB_SESSION_ID, value);

  if (typeof globalThis === 'undefined' || !('location' in globalThis)) {
    return;
  }

  globalThis.history.replaceState(
    null,
    '',
    `${globalThis.location.pathname}${buildWebSessionSearch(value, globalThis.location.search)}${globalThis.location.hash}`,
  );
};
